import { byId, isAr, message, copyText, trackEvent } from './extra-common.js';

function parseCsv(text, delimiter) {
  const rows = []; let row = []; let cell = ''; let quoted = false;
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    if (quoted) { if (char === '"' && text[i + 1] === '"') { cell += '"'; i++; } else if (char === '"') quoted = false; else cell += char; }
    else if (char === '"' && cell === '') quoted = true;
    else if (char === delimiter) { row.push(cell); cell = ''; }
    else if (char === '\n' || char === '\r') { if (char === '\r' && text[i + 1] === '\n') i++; row.push(cell); rows.push(row); row = []; cell = ''; }
    else cell += char;
  }
  if (quoted) throw new Error(isAr ? 'يوجد اقتباس غير مغلق في CSV.' : 'CSV contains an unclosed quote.');
  if (cell || row.length) { row.push(cell); rows.push(row); }
  return rows.filter((r) => !(r.length === 1 && r[0] === ''));
}
function quoteCsv(value, delimiter) { const text = String(value ?? ''); return /["\r\n]/.test(text) || text.includes(delimiter) ? `"${text.replace(/"/g, '""')}"` : text; }
function detectDelimiter(text) {
  const sample = text.slice(0, 4000);
  const commas = (sample.match(/,/g) || []).length;
  const semicolons = (sample.match(/;/g) || []).length;
  const tabs = (sample.match(/\t/g) || []).length;
  if (tabs > commas && tabs > semicolons) return '\t';
  if (semicolons > commas) return ';';
  return ',';
}

byId('cj-run').addEventListener('click', () => {
  trackEvent('tool_started', 'csv-json-converter');
  try {
    const rawVal = byId('cj-input').value.replace(/^\uFEFF/, '');
    if (!rawVal.trim()) throw new Error(isAr ? 'لا توجد بيانات لتحويلها.' : 'No data to convert.');
    const userDelimiter = byId('cj-delimiter')?.value;
    const delimiter = (!userDelimiter || userDelimiter === 'auto') ? detectDelimiter(rawVal) : userDelimiter;

    if (byId('cj-mode').value === 'csv-json') {
      const rows = parseCsv(rawVal, delimiter);
      if (!rows.length) throw new Error(isAr ? 'لا توجد بيانات لتحويلها.' : 'No data to convert.');
      const headers = rows.shift();
      const seenHeaders = new Map();
      const safeHeaders = headers.map((h, i) => {
        const base = String(h).trim() || `col_${i + 1}`;
        const count = (seenHeaders.get(base) || 0) + 1;
        seenHeaders.set(base, count);
        return count === 1 ? base : `${base}_${count}`;
      });
      const records = rows.map((row) => Object.fromEntries(safeHeaders.map((header, index) => [header, row[index] ?? ''])));
      byId('cj-output').value = JSON.stringify(records, null, 2);
    } else {
      const records = JSON.parse(byId('cj-input').value);
      if (!Array.isArray(records) || records.some((record) => !record || Array.isArray(record) || typeof record !== 'object')) throw new Error(isAr ? 'يجب أن يكون JSON مصفوفة من العناصر.' : 'JSON must be an array of records.');
      const headers = [...new Set(records.flatMap((record) => Object.keys(record)))];
      byId('cj-output').value = [headers, ...records.map((record) => headers.map((header) => record[header] ?? ''))].map((row) => row.map((value) => quoteCsv(value, delimiter)).join(delimiter)).join('\r\n');
    }
    byId('cj-copy').disabled = false;
    message('cj-status', isAr ? 'تم التحويل بنجاح.' : 'Conversion complete.', 'success');
    trackEvent('tool_completed', 'csv-json-converter');
  } catch (error) {
    byId('cj-output').value = '';
    byId('cj-copy').disabled = true;
    message('cj-status', error.message || (isAr ? 'تعذر التحويل.' : 'Conversion failed.'), 'error');
    trackEvent('tool_failed', 'csv-json-converter');
  }
});
byId('cj-copy').addEventListener('click', async () => { try { await copyText(byId('cj-output').value); message('cj-status', isAr ? 'تم النسخ.' : 'Copied.', 'success'); } catch { message('cj-status', isAr ? 'تعذر النسخ.' : 'Copy failed.', 'error'); } });

